<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content ui basic segment" [class.loading]="rateLimitProfilesLoading">
    <div class="item">
        <h3>PROFILE NAME</h3>
        <span> {{rateLimitProfile?.profileName}} </span>
    </div>

    <div class="item">
        <h3>REQUEST</h3>
        <span> {{rateLimitProfile?.quota}} </span>
    </div>

    <div class="item">
        <h3>TIME INTERVAL LIMIT</h3>
        <span> {{rateLimitProfile?.interval}} </span>
    </div>

    <div class="item">
        <h3>RESPONSE</h3>
        <span> {{rateLimitProfile?.responseMessage ? rateLimitProfile?.responseMessage : '--'}} </span>
    </div>

    <div class="item">
        <h3>DATE ASSIGNED</h3>
        <span> {{rateLimitProfile?.dateCreated | date}} </span>
    </div>

    <div class="item">
        <h3>ASSIGNED BY</h3>
        <span> {{rateLimitProfile?.createdBy | createdBy}} </span>
    </div>
</div>

<div class="actions" style="background-color: inherit !important; border: none !important;">
  <button class="ui basic primary button" (click)="modal.deny(undefined)" style="border-radius: 8px !important;">
    Back
  </button>
</div>
